import React from "react";
import { Box } from "@mui/material";
import TableDataCellWithSort from "../../../TableDataCellWithSort";
import { ISortBy } from "../../../../../types";
import newSortBy from "../../../../../utils/newSortBy";
import { useAdminProviderDataContext } from "../../../../../context";

interface IProps {
  handleSort: [ISortBy, (sortBy: ISortBy) => void];
  tableColumns: string[];
}

const TableHead: React.FC<IProps> = ({ handleSort: [sortBy, setSortBy], tableColumns }) => {
  const handleSortBy = (by: string) => newSortBy({ by, sortBy, setSortBy });
  const { user } = useAdminProviderDataContext();

  return (
    <thead>
      <Box component="tr" sx={{ position: "sticky", top: 0, zIndex: 1 }}>
        {tableColumns.includes("log_time") && (
          <TableDataCellWithSort
            sortBy={sortBy}
            by="log_time"
            title="Date"
            newSortBy={handleSortBy}
          />
        )}

        {tableColumns.includes("agent") && (
          <TableDataCellWithSort
            sortBy={sortBy}
            by="admin_accounts_id"
            title="Agent"
            newSortBy={handleSortBy}
          />
        )}
        {tableColumns.includes("action") && <td>Action</td>}
        {tableColumns.includes("previous_value") && <td>Previous value</td>}
        {tableColumns.includes("new_value") && <td>New value</td>}
        {tableColumns.includes("customer") && <td>Customer</td>}
        {tableColumns.includes("updated_agent") && user.is_manager && <td>Updated agent</td>}
        {tableColumns.includes("code") && <td>Code</td>}
      </Box>
    </thead>
  );
};

export default TableHead;
